module.exports = __webpack_public_path__ + "static/media/jaguar-bass-logo.ca05c822.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Navbar/jaguar-bass-logo.png
// module id = 390
// module chunks = 0